module.exports = "https://cwa.roocdn.com/_next/static/apple-touch-icon.e20c42b2.png";